function isEventPage({ data }) {
  let flag = false;

  if (data && data.searchModel && data.searchModel.appliedDimensions) {
    data.searchModel.appliedDimensions.forEach((element) => {
      if (element.label === 'The Home Depot Events') {
        flag = true;
      }
    });
  }

  return flag;
}

function getSchema({ schema = '', pageContext = {} }) {
  const { label, isCategory, isSearch, isBrowse } = pageContext;

  if (schema) {
    return schema;
  }

  if (label === 'browse-search') {
    if (isCategory) {
      return 'cat_sponsored';
    }
    if (isSearch) {
      return 'search_sponsored';
    }
    if (isBrowse) {
      if (isEventPage(pageContext)) {
        return 'event_browse_sponsored';
      }
      return 'browse_sponsored';
    }
  }

  return null;
}

function isBrandFpn({ experienceContext, pageContext }) {
  const { path } = experienceContext;
  const { data } = pageContext;

  const hasBrandCrumb = data?.searchModel?.taxonomy?.breadCrumbs?.some((crumb) => crumb.dimensionName === 'Brand');
  const isFeaturedProductNode = path.indexOf('/b/Featured-Products') !== -1;

  const hasBrandSearch = data?.searchModel?.metadata?.analytics?.semanticTokens
    && data.searchModel.metadata.analytics.semanticTokens.indexOf('br:{') !== -1;

  return hasBrandCrumb || hasBrandSearch || isFeaturedProductNode;
}

function getSkus({ data }) {
  let skus = '';

  if (data && data.searchModel && data.searchModel.products) {
    skus = data.searchModel.products
      .map((product) => product.itemId)
      .reduce((total, sku) => total + ',' + sku, '');

    skus = skus.substr(1);
  }

  return skus;
}

function haveProductsChanged({ lastRequestScenario, pageContext }) {
  const currentSkus = getSkus(pageContext);
  const productsUpdated = currentSkus && lastRequestScenario.skus !== currentSkus;

  return productsUpdated;
}

function isExperienceDataResolved({ isLocalized, experienceContext }) {
  const { mounted } = experienceContext;
  if (mounted && isLocalized) {
    return true;
  }
  return false;
}

function shouldMakeApiRequest({ lastRequestScenario, experienceContext, pageContext }) {
  if (isBrandFpn({ experienceContext, pageContext })) {
    return false;
  }

  const currentUrl = window.location.pathname + window.location.search;
  if (lastRequestScenario.url !== currentUrl) {
    if (pageContext.isCategory) {
      return true;
    }

    if (haveProductsChanged({ lastRequestScenario, pageContext })) {
      return true;
    }
  }

  return false;
}

function hasValidPipData(pageContext, fbtSkus) {
  if (!pageContext?.data?.itemId) return false;
  return fbtSkus.length > 0;
}

function isServer() {
  return typeof window === 'undefined';
}

function getUrlParams(url) {
  const params = {};

  try {
    url.split('?')[1].split('&').forEach((el) => {
      const keyVal = el.split('=');
      params[keyVal[0]] = keyVal[1];
    });
  } catch (error) { /* */ }

  return params;
}

function getDefaultBanner({ channel, isConsumerApp }) {
  const defaultBannerMap = [
    {
      imgDesktop: 'https://contentgrid.thdstatic.com/hdus/en_US/DTCCOMNEW/fetch/bopis-desktop.jpg',
      imgMobile: 'https://contentgrid.thdstatic.com/hdus/en_US/DTCCOMNEW/fetch/bopis-mobile.jpg',
      clickthruURL: 'https://www.homedepot.com/c/pick_up_in_store'
    },
    {
      imgDesktop: 'https://contentgrid.thdstatic.com/hdus/en_US/DTCCOMNEW/fetch/delivery-desktop.jpg',
      imgMobile: 'https://contentgrid.thdstatic.com/hdus/en_US/DTCCOMNEW/fetch/delivery-mobile.jpg',
      clickthruURL: 'https://www.homedepot.com/c/About_Your_Online_Order'
    },
  ];

  if (!isConsumerApp) {
    defaultBannerMap.push({
      imgDesktop: 'https://contentgrid.thdstatic.com/hdus/en_US/DTCCOMNEW/fetch/app-desktop.jpg',
      imgMobile: 'https://contentgrid.thdstatic.com/hdus/en_US/DTCCOMNEW/fetch/app-mobile.jpg',
      clickthruURL: 'https://www.homedepot.com/c/SF_Mobile_Shopping'
    });
  }

  const defaultBanner = defaultBannerMap[Math.floor(Math.random() * defaultBannerMap.length)];
  defaultBanner.url = defaultBanner.imgDesktop;
  if (channel === 'mobile') {
    defaultBanner.url = defaultBanner.imgMobile;
  }

  let imgSrc = defaultBanner.url;
  let href = defaultBanner.clickthruURL;
  if (typeof window !== 'undefined') {
    try {
      const aTag = window.document.querySelector('#default_banner_carousel a');
      const img = window.document.querySelector('#default_banner_carousel img');

      href = aTag.href;
      imgSrc = img.src;
    } catch (error) { /* */ }
  }

  const paddingTop = channel === 'mobile' ? '37.7%' : '10.6%';

  const spacingCss = {
    width: '100%',
    display: 'block',
    boxSizing: 'border-box',
    position: 'relative',
    paddingTop
  };
  const bgCss = {
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    backgroundImage: `url("${imgSrc}")`,
  };

  return { spacingCss, bgCss, href, imgSrc };
}

function getMockPlaData(itemId) {
  return [
    {
      id: `${itemId}`,
      itemType: 'MERCHANDISE',
      // eslint-disable-next-line max-len
      imageURL: 'some-image.jpg',
      canonicalURL: `/p/${itemId}`,
      brand: 'Mock brand',
      productName: 'Mock product',
      price: 654.96,
      uom: 'each',
      slotId: '12485',
      campaignId: 109105,
      placementId: 23,
      // eslint-disable-next-line max-len
      onViewBeacon: 'https://ad-thd-east.tagdelivery.com/impression?id=4769a8f7-4d93-4261-bd76-c9d117f4ebc6&x=c3paeMtETMO4IlfeLVovMwe88pDevlQiWyFP6oEyO-3a5h4XD8L7pcUgkeqHQRs0_BQpaXlzlc-53Ri1X8y53YKyN0vrVr8bSOTBRVZOjAibUUrbaI8JlbqpsBXdsBQsKu6FI6PqUllVYeRv1j5_BwS7iDilHRf-q4W_Qd9izGhHfnt5pN_oywasjjqlnicW_K1WEhh4HVRWNtintwEPmgLxmRV7kbvmYHGMPs5k56goIAONpk0yOTFJvzgt-UP9Y-W563OkwfuNWzzkkH0JD0myav8Q6C2JzOWZopwxJEv_JIyj-vumPhmCT2XqYucD40HKiBSyrAEwSXwmTbfaBoSwcs55j9Hp6so7Q394Ye39InDACeLVoW_NU_WPOfsJaclZOkrfIeUU_5JBTz5y590iJDLQTWvlWPwxPdyh-xE%3D',
      // eslint-disable-next-line max-len
      onClickBeacon: 'https://ad-thd-east.tagdelivery.com/click?id=4769a8f7-4d93-4261-bd76-c9d117f4ebc6&x=c3paeMtETMO4IlfeLVovMwe88pDevlQiWyFP6oEyO-3a5h4XD8L7pcUgkeqHQRs0_BQpaXlzlc-53Ri1X8y53YKyN0vrVr8bSOTBRVZOjAibUUrbaI8JlbqpsBXdsBQsKu6FI6PqUllVYeRv1j5_BwS7iDilHRf-q4W_Qd9izGhHfnt5pN_oywasjjqlnicW_K1WEhh4HVRWNtintwEPmgLxmRV7kbvmYHGMPs5k56goIAONpk0yOTFJvzgt-UP9Y-W563OkwfuNWzzkkH0JD0myav8Q6C2JzOWZopwxJEv_JIyj-vumPhmCT2XqYucD40HKiBSyrAEwSXwmTbfaBoSwcs55j9Hp6so7Q394Ye39InDACeLVoW_NU_WPOfsJaclZOkrfIeUU_5JBTz5y590iJDLQTWvlWPwxPdyh-xE%3D&redirect='
    }
  ];
}

function isEventBusCreated() {
  return typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS;
}

export {
  isEventPage, isServer,
  shouldMakeApiRequest, getUrlParams, getSchema, isBrandFpn,
  haveProductsChanged, getSkus, getDefaultBanner, getMockPlaData,
  isEventBusCreated, hasValidPipData, isExperienceDataResolved
};
